import { render, staticRenderFns } from "./BaseAbout.vue?vue&type=template&id=1de583c9&scoped=true"
import script from "./BaseAbout.vue?vue&type=script&lang=js"
export * from "./BaseAbout.vue?vue&type=script&lang=js"
import style0 from "./BaseAbout.vue?vue&type=style&index=0&id=1de583c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de583c9",
  null
  
)

export default component.exports